import React, {useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import './Navbar.css';
import logo from './logo.png';
import UA_Flag from './UKR_Flag.png';
import USA_Flag from './USA_Flag.png';

import { useTranslation } from 'react-i18next';


const Navbar = () => {

    const { t, i18n } = useTranslation();
    const location = useLocation();
    // const [menu, setMenu] = useState("General");
    // це відноситься до закоментованого коду, коли додали useLocation
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 680);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 680);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    return (
        <section className='navbar'>
            <div className='content-wrap'>
                <div className='nav-upper'>
                    <div className="nav-upper_logo d-flex space-between">
                        <img className='img-logo' src={logo} alt="logo"/>
                        <p>ТРАНЗІТ ТРАК</p>
                        <div>
                            <button onClick={() => i18n.changeLanguage('ua')}>
                                <img src={UA_Flag} alt="UA_Flag"/>
                                <span>UA</span>
                            </button>
                            <button onClick={() => i18n.changeLanguage('en')}>
                                <img src={USA_Flag} alt="USA_Flag"/>
                                <span>USA</span>
                            </button>
                        </div>
                    </div>
                    <div className="nav-upper_contacts d-flex space-center">
                        <div className="nav-upper-tel">
                            <i className="fa-solid fa-phone-volume"></i>
                            <a href="tel:+380503526543">+38 (050) 352-65-43</a>
                        </div>
                        <div className="nav-upper_soсial d-flex space-between">
                            <a href="https://facebook.com">
                                <i className="fa-brands fa-facebook"></i>
                            </a>
                            <a href="https://www.instagram.com">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <ul className="nav-menu d-flex space-center">
                    <li>
                        <Link to='/'>
                            {t('main')}{location.pathname === '/' && <hr/>}</Link>
                    </li>
                    <li>
                        <Link to='/AdBlue'>AdBlue{location.pathname === '/AdBlue' && <hr/>}</Link>
                    </li>
                    <li>
                        <Link to='/MineralFertilizers'>
                            {isMobile ? t('mineral_fertilizers_short') : t('mineral_fertilizers')}
                            {location.pathname === '/MineralFertilizers' && <hr/>}
                        </Link>
                    </li>
                </ul>

                {/*<ul className="nav-menu d-flex space-center">*/}
                {/*    <li onClick={() => {*/}
                {/*        setMenu('General')*/}
                {/*    }}><Link to='/'>Головна{menu === 'General' ? <hr/> : <></>}</Link></li>*/}
                {/*    <li onClick={() => {*/}
                {/*        setMenu('AdBlue')*/}
                {/*    }}><Link to='/AdBlue'>AdBlue{menu === 'AdBlue' ? <hr/> : <></>}</Link></li>*/}
                {/*    <li onClick={() => setMenu('MineralFertilizers')}>*/}
                {/*        <Link to='/MineralFertilizers'>*/}
                {/*            {isMobile ? 'Мін добрива' : 'Мінеральні добрива'}*/}
                {/*            {menu === 'MineralFertilizers' && <hr/>}*/}
                {/*        </Link>*/}
                {/*    </li>*/}
                {/*</ul>*/}
            </div>
        </section>
    )
}

export default Navbar;